import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";

// Base URL for the header messages API
const baseUrl = `${baseURL}/home-settings/`;

export const headerMessageApiService = createApi({
  reducerPath: "headerMessageApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice.token; // Adjust the path to your token in the state

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Query to get all header messages
    getAllHeaderMessages: builder.query({
      query: () => "header-message",
    }),
    // Query to get all carousel data
    getAllCarousel: builder.query({
      query: () => "carousel",
    }),
  }),
});

// Export hooks for usage in functional components
export const { useGetAllHeaderMessagesQuery, useGetAllCarouselQuery } =
  headerMessageApiService;
